import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { LocaleProvider, useLocalePrefixParam, isValidLocalePrefix } from '../context/LocaleContext';

/** Wraps default-locale routes (no path prefix). Provides locale context and renders child route. */
export function DefaultLocaleLayout() {
  return (
    <LocaleProvider pathPrefix="">
      <Outlet />
    </LocaleProvider>
  );
}

/** Wraps /:localePrefix/... routes. Validates locale and provides context; invalid prefix -> 404. */
export function LocalePrefixLayout() {
  const localePrefix = useLocalePrefixParam();
  if (!isValidLocalePrefix(localePrefix)) {
    return <Navigate to="/404" replace />;
  }
  return (
    <LocaleProvider pathPrefix={localePrefix}>
      <Outlet />
    </LocaleProvider>
  );
}
